import React, { createContext, useContext, useState, useEffect } from 'react';
import io from 'socket.io-client';
import { UserContext } from './UserProvider';
// import { UserContext } from './UserProvider';

const ChatContext = createContext();

export const useChat = () => {
    return useContext(ChatContext);
}

export const ChatProvider = ({ children }) => {
    const { stateUser } = useContext(UserContext);

    const [socket, setSocket] = useState(null);
    const [userName, setUserName] = useState('hcerna');
    const [currentRoom, setCurrentRoom] = useState(null);
    const [connectionError, setConnectionError] = useState(false);

    useEffect(() => {

        const initializeSocket = () => {
            const newSocket = io.connect(process.env.REACT_APP_HELP_CENTER,{

                transports: ['websocket'],
                auth: {
                    token: stateUser?.token,
                    name: stateUser?.uid // Asegúrate de tener acceso a stateUser.nomUsuario
                },
                autoConnect: true
            });

            newSocket.on('connect_error', (error) => {
                console.error('Socket connection error:', error);
                setConnectionError(true);
            });

            return newSocket;
        };

        const newSocket = initializeSocket();

        // Agregar un registro cuando el socket se conecta
        newSocket.on('connect', () => {
            setConnectionError(false);
        });

        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
            // localStorage.clear();
            // window.location.href = '/login';
        };
    }, [userName]);

    const value = {
        socket,
        userName,
        setUserName,
        setCurrentRoom,
        currentRoom,
        connectionError
    };

    return (
        <ChatContext.Provider value={value}>
            {children}
        </ChatContext.Provider>
    );
};
